import type { PersonSource } from '../../entities/personSource/personSourceTypes';
import { MOCK_GROUP_ID } from './mockSite';

const audit = {
  companyId: 1,
  groupId: MOCK_GROUP_ID,
  userId: 1,
  userName: 'Sistema',
  createDate: '2026-01-10T10:00:00Z',
  modifiedDate: '2026-01-10T10:00:00Z',
};

/**
 * Lookup mock per PersonSource. I 5 nomi qui corrispondono 1:1 ai
 * valori usati come stringa libera nei mockPersons (Web/Referral/
 * Fiera/Email/Telefono). L'array è mutabile: il handler MSW
 * POST/PATCH /people/:groupId fa append in caso di find-or-create
 * (vedi mockHandlers.ts) usando `nextPersonSourceId` per il prossimo id.
 */
export const mockPersonSources: PersonSource[] = [
  { personSourceId: 1, name: 'Web', ...audit },
  { personSourceId: 2, name: 'Referral', ...audit },
  { personSourceId: 3, name: 'Fiera', ...audit },
  { personSourceId: 4, name: 'Email', ...audit },
  { personSourceId: 5, name: 'Telefono', ...audit },
];

// Counter privato al modulo per i find-or-create (vedi mockHandlers.ts).
// Allineato al pattern di `let nextId = 10000` in mockHandlers.ts: niente
// export per evitare riassegnamenti accidentali da consumer; l'unica API
// pubblica e' consumeNextPersonSourceId().
let nextPersonSourceId = 6;

/** Avanza il counter e ritorna il valore precedente. */
export function consumeNextPersonSourceId(): number {
  return nextPersonSourceId++;
}
